type ConfluenceDraftSiblingParentResponse = {
	status?: string | null;
	ancestors?: ReadonlyArray<{ id?: string | null } | null> | null;
} | null;

export const resolveConfluenceDraftSiblingParent = async (
	contentId: string,
): Promise<string | undefined> => {
	try {
		const response = await fetch(
			`/wiki/rest/api/content/${encodeURIComponent(contentId)}?expand=ancestors,status&status=draft,current`,
			{ credentials: 'include' },
		);
		if (!response.ok) {
			return undefined;
		}

		const payload = (await response.json()) as ConfluenceDraftSiblingParentResponse;
		if (payload?.status !== 'draft') {
			return undefined;
		}

		const ancestors = payload.ancestors;
		if (!ancestors || ancestors.length === 0) {
			return undefined;
		}

		const directParentId = ancestors[ancestors.length - 1]?.id;
		return typeof directParentId === 'string' ? directParentId : undefined;
	} catch {
		return undefined;
	}
};
